import { apiClient } from './client';

const BASE = '/api/reports/prompt-templates';

/**
 * Shared library of saved prompts for custom reports. Picking a template only
 * copies its text, so editing a report never changes the template.
 */
export const promptTemplateApi = {
  list: async (search = '') => {
    const response = await apiClient.get(`${BASE}/`, { params: search ? { search } : undefined });
    return response.data;
  },

  create: async ({ name, prompt }) => {
    const response = await apiClient.post(`${BASE}/`, { name, prompt });
    return response.data;
  },

  update: async (templateId, { name, prompt } = {}) => {
    const response = await apiClient.patch(`${BASE}/${templateId}`, { name, prompt });
    return response.data;
  },

  remove: async (templateId) => {
    await apiClient.delete(`${BASE}/${templateId}`);
  },
};
